import { render } from "./PR5-051022.vue?vue&type=template&id=642290f4"
import script from "./PR5-051022.vue?vue&type=script&lang=js"
export * from "./PR5-051022.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__